import { useEffect, useState } from "react";
import { getInfoTextService } from "../../../../services/infoTextService";
//import { datosConfig } from "../../../helpers/data"
import Coberturas from "../components/Coberturas";
import Contacto from "../components/Contacto";
import FormatosGuias from "../components/FormatosGuias";
import HeadHomeOut from "../components/HeadHomeOut";
import PreguntasFrecuentes from "../components/PreguntasFrecuentes";
//import Seguro from "../components/Seguro"
import Siniestro from "../components/Siniestro";
import { Ecosistema } from "../components/Ecosistema";
import { ActivarCuenta } from "../components/ActivarCuenta";
import SidebarButton from "../../../../components/sidebar/SidebarButton";
import ModalNewPasswordSuccess from "../components/modal/ModalNewPasswordSuccess";
import SidebarLogin from "../../../../components/sidebar/SidebarLogin";
import SpinnerCuadrado from "../../../helpers/SpinnerCuadrado";
import ModalActivarCuentaSuccess from "../components/modal/ModalActivarCuentaSuccess";
import WhatsAppBubble from "../components/bubble/WhatsAppBubble";
import GoogleReview from "../components/GoogleReview";

const HomeOutScreen = () => {
  const [coberturas, setCoberturas] = useState();
  const [coberturasDesc, setCoberturasDesc] = useState();
  const [ecosistemas, setEcosistemas] = useState();
  const [siniestros, setSiniestros] = useState();
  const [pasosSiniestros, setPasosSiniestros] = useState();
  const [preguntas, setPreguntas] = useState();
  const [infoApi, setInfoApi] = useState();
  const [objUsuarioLogin, setObjUsuarioLogin] = useState({
    usuario: "",
    password: "",
    sitioPassword: "",
    sitioUsuario: "",
    deviceInfo: "",
    tokenCaptcha: "",
  });

  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [showModalActivaSuccess, setShowModalActivaSuccess] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getInfoTextService()
      .then((resp) => {
        setCoberturas(resp.CoberturaCards);
        setCoberturasDesc(resp.CoberturaDesc);
        setSiniestros(resp.TabsSiniestro);
        setPasosSiniestros(resp.PasosSiniestro);
        setPreguntas(resp.PreguntasFrecuentes);
        setEcosistemas(resp.EcosistemaCards);
        setInfoApi(resp.InfoApi);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return (
    <>
      {loading && <SpinnerCuadrado />}

      <ModalNewPasswordSuccess
        infoApi={infoApi}
        show={showModalSuccess}
        setShow={setShowModalSuccess}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />

      <ModalActivarCuentaSuccess
        infoApi={infoApi}
        show={showModalActivaSuccess}
        close={setShowModalActivaSuccess}
        objUsuarioLogin={objUsuarioLogin}
        setLoading={setLoading}
      />

      <SidebarLogin
        infoApi={infoApi}
        show={showLogin}
        setShow={setShowLogin}
        setShowModalSuccess={setShowModalSuccess}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />

      <SidebarButton
        infoApi={infoApi}
        setShowModalSuccess={setShowModalSuccess}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
      />
      <HeadHomeOut />
      <WhatsAppBubble />
      <Coberturas coberturas={coberturas} coberturasDesc={coberturasDesc} />
      <Ecosistema ecosistemas={ecosistemas} />
      <ActivarCuenta
        infoApi={infoApi}
        setMostrarLogin={setShowLogin}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />
      <Siniestro siniestros={siniestros} pasosSiniestros={pasosSiniestros} />
      <FormatosGuias />
      <PreguntasFrecuentes preguntas={preguntas} />
      <GoogleReview reviewUrl="https://bnppc-mx.encender.cloud/redirect?canal=website&nombre=producto" />
      <Contacto />
    </>
  );
};

export default HomeOutScreen;
